import { render, staticRenderFns } from "./revision_dropdown.vue?vue&type=template&id=5a0f6a76"
import script from "./revision_dropdown.vue?vue&type=script&lang=js"
export * from "./revision_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports